<!--Test:Hi, 新的组件 2020/06/18 14:26:54 YuAng-->

<template>
   <div class="xx-Test">{{tip}}</div>
</template>
<script>
export default {
  name: 'Test',
  props: {
     item:  {
        type: Object,
        default: function () {
           return {}
        }
     }
  },
  data () {
       return {
        tip: 'Hi, 新的组件'
       }
  },
  created () {
     // 请求接口
  },
  mounted () {
     // 更新Dom
  },
  methods: {
     xxxAction: function (action) {
        console.log(action)
     }
  }
}
</script>

<style scoped>
.xx-Test {
   color: brown;
}
</style>